/**
 * Format the news date. Example: 23 DE JUNIO DE 2025
 * @param {string} date 
 * @returns {string}
 */

export default function NewsDateFormatter(date: string): string{
    const dateWithInitialTime = new Date(`${date}T12:00:00`)

    return dateWithInitialTime.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "long",
        year: "numeric"
    }).toUpperCase();
}